import { useQuery } from '@tanstack/vue-query';
import { computed, type MaybeRefOrGetter } from 'vue';
import { flokService } from '@/modules/flokee/services/flok.service';
import { toValue } from 'vue';

export const useEcommerceSuccessCalculator = (ecommerce_id?: MaybeRefOrGetter<number>) => {
  const ecommerceId = computed(() => toValue(ecommerce_id));

  const enabled = computed(() => !!ecommerceId.value);

  const { data, isLoading } = useQuery({
    queryKey: ['ecommerce-success-calculator', ecommerceId],
    queryFn: ({ queryKey: [, id] }) => {
      if (!id) return;
      return flokService.getEcommerceSuccessCalculator(id as number);
    },
    select: (response) => response?.data,
    enabled: enabled,
    notifyOnChangeProps: 'all',
    gcTime: Infinity,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

  return {
    //data
    data,
    isLoading,
  };
};
